import React from "react";
import Experience from "../Items/Experience";

const experiencesData = [
  {
    id: 1,
    year: "jan-21 - Nov-21",
    degree: "Africa Trainovation Consulting (ATC) ",
    content:
      "During my internship at Africa Trainovation Consulting (ATC), a leading digital hub specializing in innovative training, skills acquisition, and consultancy, I had the invaluable opportunity to serve as a frontend mentor.",
    
  },
  {
    id: 2,
    year: "Dec-2022 - May-2023",
    degree: "Farmily Africa",
    content:
      "At Farmily Africa, a dedicated ecommerce platform, I played a pivotal role in the development team responsible for building the MVP website, including its authentication systems.",
   
  },
  {
    id: 3,
    year: "Oct-2023 - present",
    degree: "Acre",
    content:
      "At Acre, my current workplace, I serve as a frontend engineer collaborating closely with backend engineers. Together, we're dedicated to crafting an Agrotech web page aimed at addressing real-world challenges within the agriculture ecosystem.",
  },
];

function Experiences() {
  return (
    <div className="timeline">
      {experiencesData.map((experience) => (
        <Experience experience={experience} key={experience.id} />
      ))}
      <span className="timeline-line"></span>
    </div>
  );
}

export default Experiences;
